import { extractDownloadUrl } from '../../common/detail';
import { extractPreview as extractPreviewData, extractLink, extractProvider, extractTitle } from '@atlaskit/link-extractors';
import { extractLinkIcon } from '../icon';
import { extractIsSupportTheming } from '../../common/meta/extractIsSupportTheming';
import { CardAction } from '../../../view/Card/types';
import { canShowAction } from '../../../utils/actions/can-show-action';
export const extractPreviewAction = (response, actionOptions) => {
  var _extractPreviewData;
  if (!canShowAction(CardAction.PreviewAction, actionOptions)) {
    return;
  }
  const data = response.data;
  const meta = response.meta;
  const src = (_extractPreviewData = extractPreviewData(data, 'web')) === null || _extractPreviewData === void 0 ? void 0 : _extractPreviewData.src;
  if (src) {
    var _extractProvider;
    return {
      downloadUrl: extractDownloadUrl(data),
      providerName: (_extractProvider = extractProvider(data)) === null || _extractProvider === void 0 ? void 0 : _extractProvider.text,
      src,
      title: extractTitle(data),
      linkIcon: extractLinkIcon(response),
      url: extractLink(data),
      isSupportTheming: extractIsSupportTheming(meta)
    };
  }
};